import { ApiService } from '@core/services/common';
import { API_ENDPOINT } from '@core/configs';
import { firstValueFrom } from 'rxjs';
import { Injectable } from '@angular/core';
import { DeleteCareconneRoleDTO } from '@core/models/dto/careconne-company.dto';
import { CompanyPaginateDTO } from '@core/models/dto/paginate.dto';
import { CareconneCompanyPaginateRO } from '@core/models/ro/careconne-company.ro';

@Injectable({
  providedIn: 'root',
})
export class CareconneCompanyService {
  constructor(private readonly http: ApiService) {}

  getPaginate(query: CompanyPaginateDTO) {
    return firstValueFrom(
      this.http.getWithQuery<CareconneCompanyPaginateRO>(
        API_ENDPOINT.careconneCompany.controller + API_ENDPOINT.careconneCompany.paginate,
        query as any,
      ),
    );
  }

  deleteCareconneRole(data: DeleteCareconneRoleDTO) {
    return this.http.delete(
      API_ENDPOINT.careconneCompany.controller +
      API_ENDPOINT.careconneCompany.deleteCareconneRole,
      data,
    );
  }

  updatedXmlStatus() {
    return this.http.put(
      API_ENDPOINT.careconneCompany.controller +
      API_ENDPOINT.careconneCompany.updatedXmlStatus,
    );
  }

  getInfosentLinked(organizationId: number, companyId: number) {
    return this.http.post(API_ENDPOINT.careconneCompany.controller + API_ENDPOINT.careconneCompany.getInfosentLinked, {
      organizationId,
      companyId,
    });
  }
}
